import {
  Box,
  IconButton,
  Typography,
  Badge,
  Button,
  Link,
} from "@mui/material";
import { useLocation, Link as RouterLink, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { enToFaDigit } from "../../utility/utils";
import Cookies from "js-cookie";
import React, { forwardRef, useMemo } from "react";
const BottomNav = ({ customItems }) => {
  const { search } = useLocation();
  let query = new URLSearchParams(search);
  const config = useSelector((state) => state.config);
  const cart = useSelector((state) => state.cart);
  const history = useHistory();
  const cartList = cart.list;
  var count = 0;

  const agentService = window.localStorage.getItem("agent_service");
  const isShahrzad = agentService === "shahrzad" || agentService === "splus";

  cartList?.map((item) => {
    count = count + item?.number;
  });
  const items = customItems || config.NavBoxItems || [];
  var showFromApp = query.get("from") === "app";
  let from = localStorage.getItem("from");
  if ((from && from === "app") || Cookies.get("token") === undefined) {
    showFromApp = true;
  } else if (query.get("from") === "app") {
    localStorage.setItem("from", "app");
  }

  // const CustomLink = React.useMemo(
  //   () =>
  //     forwardRef(function Link(linkProps, ref) {
  //       return <RouterLink ref={ref} {...linkProps} />;
  //     }),
  //   []
  // );
  // console.log(history.length);
  if (isShahrzad && window.location.pathname === "/survey") return null;
  return (
    <Box
      sx={{
        display: {
          xs: showFromApp ? "none" : "flex",
          md: "none",
        },
        width: "100%",
        height: "70px",
        bgcolor: "primary.main",
        position: "fixed",
        bottom: "0",
        left: "0",
        justifyContent: "space-between",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      {items.map((item) => {
        if (isShahrzad && item.name == "دربستی")
          return (
            <Button
              key={item.path}
              sx={{
                height: "100%",
                width: `${100 / items.length}%`,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: item.path.includes(window.location.pathname)
                  ? "brightness(60%)"
                  : null,
              }}
              disabled
            >
              <Badge
                badgeContent={
                  <span
                    style={{
                      fontSize: 9,
                      paddingBottom: 2,
                    }}
                  >
                    به‌زودی
                  </span>
                }
                color="secondary"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                overlap="circular"
                sx={{
                  p: 0,
                  "& .MuiBadge-badge": {
                    height: 14,
                    bgcolor: "#777",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              >
                <IconButton
                  size="large"
                  sx={{
                    color: "#fff8",
                    mb: 1,
                  }}
                >
                  <item.icon fontSize="large" />
                </IconButton>
              </Badge>
              <Typography
                sx={{
                  width: "120px",
                  fontSize: "10px",
                  position: "absolute",
                  bottom: "5px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  color: "#fff8",
                  transition: "all 0.3s ease-in-out",
                }}
                align="center"
              >
                {item.name}
              </Typography>
            </Button>
          );

        return (
          <Link
            component={RouterLink}
            replace={isShahrzad && window.location.pathname !== "/paths"}
            onClick={
              isShahrzad && item.path == "/paths"
                ? (e) => {
                    // console.log(history.length);
                    e.preventDefault();
                    window.localStorage.setItem("forceHome", "true");
                    history.go(-1);
                  }
                : () => console.log("really?")
            }
            to={item.path}
            key={item.path}
            sx={{
              height: "100%",
              width: `${100 / items.length}%`,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: item.path.includes(window.location.pathname)
                ? "brightness(60%)"
                : null,
            }}
          >
            {item?.path === "/cart" && cartList.length > 0 ? (
              <IconButton
                size="large"
                sx={{
                  color: "#fff",
                  mb: 1,
                }}
              >
                <Badge
                  badgeContent={enToFaDigit(count + "")}
                  color="secondary"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  overlap="circular"
                  style={{
                    transform: "translate(-50%, -50%)",
                    top: "13px",
                    right: "13px",
                    position: "absolute",
                  }}
                ></Badge>
                <item.icon fontSize="large" />
              </IconButton>
            ) : (
              <IconButton
                size="large"
                sx={{
                  color: "#fff",
                  mb: 1,
                }}
              >
                <item.icon fontSize="large" />
              </IconButton>
            )}
            <Typography
              sx={{
                width: "120px",
                fontSize: "10px",
                position: "absolute",
                bottom: "5px",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#fff",
                transition: "all 0.3s ease-in-out",
              }}
              align="center"
            >
              {item.name}
            </Typography>
          </Link>
        );
      })}
    </Box>
  );
};

export default BottomNav;
